export default __webpack_public_path__ + "static/media/linky_logo2.760bcf6c.png";